import React from 'react'
import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import { withStyles /* , Grid  */ } from '@material-ui/core'
import conversationItemTypes from './conversationItemTypes'
import AvatarWithLabel from '../AvatarWithLabel'
import moment from 'moment'
// import contactLabel from 'utils/contactLabel'
import { capitalize } from 'lodash'
import { PhoneInTalk, PhoneMissed } from 'mdi-material-ui'
// import { Phone } from '@material-ui/icons'
import inboxItemLabels from 'utils/inboxItemLabels'
import secondsToString from 'utils/secondsToString'

const styles = theme => ({
  threadItemContainer: {
    padding: '10px 20px 10px 60px',
    position: 'relative',
  },
  threadItem: {
    backgroundColor: '#f1f1f1',
    padding: '12px 16px 12px 62px',
    borderRadius: 13,
    position: 'relative',
    minHeight: 64,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  threadItemMobile: {
    backgroundColor: '#f1f1f1',
    padding: 12,
    borderRadius: 13,
    position: 'relative',
    minHeight: 64,
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
  },
  avatar: {
    position: 'absolute',
    top: 12,
    left: 12,
  },
  secondAvatar: {
    position: 'absolute',
    top: 12,
    right: 12,
  },
  iconContainer: {
    position: 'absolute',
    top: '50%',
    left: 14,
    transform: 'translate(0, -50%)',
    textAlign: 'center',
  },
  icon: {
    fill: '#c2c2c2',
    fontSize: 30,
  },
  iconLabel: {
    fontSize: 10,
    color: '#c2c2c2',
    marginTop: '-4px',
  },
  dateAndStatus: {
    color: '#5f5f5f',
    position: 'absolute',
    top: 29,
    left: '50%',
    transform: 'translateX(-50%)',
    whiteSpace: 'nowrap',
    fontSize: 12,
  },
  dateAndStatusContainer: {
    display: 'inline-block',
    width: 'calc(50% - 56px)',
    position: 'relative',
  },
  dateAndStatusContainerMobile: {
    position: 'absolute',
    top: '50%',
    transform: 'translate(0, -50%)',
  },
  callIcon: {
    position: 'absolute',
    top: 6,
    left: '50%',
    transform: 'translate(-50%)',
    textAlign: 'center',
  },
})

const PhoneItem = ({
  classes,
  key,
  conversationItem,
  contact,
  businessName,
  accountName,
}) => {
  const Icon = conversationItemTypes[conversationItem.type].icon

  const date =
    conversationItem.timestamp &&
    (moment(conversationItem.timestamp).isSame(new Date().toISOString(), 'Date')
      ? `Today at ${moment(conversationItem.timestamp).format('h:mm A')}`
      : moment(conversationItem.timestamp).format('ddd, MMM D, YYYY h:mm A'))

  const call = conversationItem.call
  if (!call) return null

  return (
    <div key={key} className={classes.threadItemContainer}>
      <div className={classes.iconContainer}>
        <Icon className={classes.icon} />
        <div className={classes.iconLabel}>
          {conversationItemTypes[conversationItem.type].label}
        </div>
      </div>
      <div className={classes.threadItem}>
        <div className={classes.avatar}>
          <AvatarWithLabel
            type={conversationItem.direction === 'inbound' ? 'contact' : 'user'}
            contact={contact}
            label={inboxItemLabels({
              personType: 'sender',
              itemType: 'call',
              item: conversationItem,
              businessName,
              accountName,
              contact,
            })}
          />
        </div>
        <div className={classes.secondAvatar}>
          <AvatarWithLabel
            type={conversationItem.direction === 'inbound' ? 'user' : 'contact'}
            contact={contact}
            label={inboxItemLabels({
              personType: 'recipient',
              itemType: 'call',
              item: conversationItem,
              businessName,
              accountName,
              contact,
            })}
          />
        </div>
        <div
          style={{
            fontSize: 14,
            minHeight: 52,
          }}
        >
          <div className={classes.dateAndStatusContainer}>
            <span style={{ position: 'absolute', left: 0, fontWeight: 'bold' }}>
              {inboxItemLabels({
                personType: 'sender',
                itemType: 'call',
                item: conversationItem,
                businessName,
                accountName,
                contact,
              })}
            </span>
            <span className={classes.dateAndStatus}>{date}</span>
          </div>
          <div
            style={{
              width: 62,
              display: 'inline-block',
            }}
          />
          <div className={classes.dateAndStatusContainer}>
            <span
              style={{ position: 'absolute', right: 0, fontWeight: 'bold' }}
            >
              {inboxItemLabels({
                personType: 'recipient',
                itemType: 'call',
                item: conversationItem,
                businessName,
                accountName,
                contact,
              })}
            </span>
            <span className={classes.dateAndStatus}>
              {call && call.duration
                ? `Duration - ${secondsToString(call.duration)}`
                : call && call.status && capitalize(call.status)}
            </span>
          </div>
          <span className={classes.callIcon}>
            {call && call.status === 'canceled' ? (
              <PhoneMissed style={{ fontSize: 36, color: '#C2C2C2' }} />
            ) : (
              <PhoneInTalk style={{ fontSize: 36, color: '#C2C2C2' }} />
            )}
            <div style={{ fontSize: 12, color: '#a7a6a6' }}>CALLED</div>
          </span>
        </div>
      </div>
      <div className={classes.threadItemMobile}>
        <div
          style={{
            position: 'relative',
            height: 53,
            paddingLeft: 49,
            marginBottom: 5,
            fontSize: 14,
          }}
        >
          <div style={{ position: 'absolute', left: 0, top: 0 }}>
            <AvatarWithLabel
              type={
                conversationItem.direction === 'inbound' ? 'contact' : 'user'
              }
              contact={contact}
              label={inboxItemLabels({
                personType: 'sender',
                itemType: 'call',
                item: conversationItem,
                businessName,
                accountName,
                contact,
              })}
            />
          </div>
          <div className={classes.dateAndStatusContainerMobile}>
            <div style={{ fontWeight: 'bold' }}>
              {inboxItemLabels({
                personType: 'sender',
                itemType: 'call',
                item: conversationItem,
                businessName,
                accountName,
                contact,
              })}
            </div>
            <div style={{ color: '#5f5f5f', fontSize: 12 }}>{date}</div>
          </div>
        </div>
        <div style={{ textAlign: 'center' }}>
          {call && call.status === 'canceled' ? (
            <PhoneMissed style={{ fontSize: 36, color: '#C2C2C2' }} />
          ) : (
            <PhoneInTalk style={{ fontSize: 36, color: '#C2C2C2' }} />
          )}
          <div style={{ fontSize: 12, color: '#a7a6a6' }}>CALLED</div>
        </div>
        <div
          style={{
            position: 'relative',
            height: 53,
            paddingLeft: 49,
            marginTop: 5,
            fontSize: 14,
          }}
        >
          <div style={{ position: 'absolute', right: 0, top: 0 }}>
            <AvatarWithLabel
              type={
                conversationItem.direction === 'inbound' ? 'user' : 'contact'
              }
              contact={contact}
              label={inboxItemLabels({
                personType: 'recipient',
                itemType: 'call',
                item: conversationItem,
                businessName,
                accountName,
                contact,
              })}
            />
          </div>
          <div
            style={{ right: 49 }}
            className={classes.dateAndStatusContainerMobile}
          >
            <div style={{ fontWeight: 'bold' }}>
              {inboxItemLabels({
                personType: 'recipient',
                itemType: 'call',
                item: conversationItem,
                businessName,
                accountName,
                contact,
              })}
            </div>
            <div style={{ color: '#5f5f5f', fontSize: 12 }}>
              {call && call.duration
                ? `Duration - ${secondsToString(call.duration)}`
                : call && call.status && capitalize(call.status)}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default connect(
  (state) => ({
    businessName:
      state.AccountSettings.settings &&
      state.AccountSettings.settings.business_name,
    accountName:
      state.AccountSettings.settings && state.AccountSettings.settings.name,
  }),
  null,
)(withStyles(styles)(PhoneItem))
